export const MAX_SLOTS = 8;

export const isMobile = window.innerWidth <= 768;
